import './App.css';
import {
    Routes,
    Route
} from "react-router-dom";
import Navbar from './Pages/Navbar';
import HomePage from './Pages/Home';
import FilePage from './Pages/FileInsert';
import PrintPage from './Pages/PrintChoice';
import SubmitPage from './Pages/Submit';
import ProfilePage from './Pages/Profile';


function App() {
    return (
        <div>
            <Navbar />
            <div style={styles.home}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/print" element={<FilePage />} />
                    <Route path="/print-2" element={<PrintPage />} />
                    <Route path="/submit" element={<SubmitPage />} />
                    <Route path="/confirmation" element={<SubmitPage />} />
                </Routes>
            </div>
        </div>
    );
}

const styles = {
    home: {
        padding: 30,
    },
};

export default App;
